import Typography from "@material-ui/core/Typography";
import { useFormik } from "formik";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { Button } from "@material-ui/core";
import React, { useCallback, useEffect, useMemo } from "react";
import { themeButtons } from "../../../css/themeButtons";
import { useHistory } from "react-router-dom";

const FastChooseCM = (
  {
    channelManagerList,
    getChannelManagerList,
    channelManager,
    goPage,
    objectId,
    setChannelManagerPage,
    updateSavingStatus,
    setStatusStepByStep,
    getObjectsList,
    getObjectById,
    firstRoom,
  }
) => {

  const history = useHistory();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, [])

  useEffect(() => {
    if (!channelManagerList) {
      getChannelManagerList()
    }
  }, [channelManagerList, getChannelManagerList])


  const handleEndCreate = useCallback(async () => {
    updateSavingStatus({ status: "loading" })

    setStatusStepByStep("N")
    await getObjectById(objectId)

    await getObjectsList();
    updateSavingStatus(false)
    history.replace(`/lk/contracts/${objectId}`)
  }, [getObjectById, getObjectsList, history, objectId, setStatusStepByStep, updateSavingStatus])


  /**
   * Сабмит формы
   */
  const onSubmit = async (value) => {
    await setChannelManagerPage({
      object: objectId,
      section: "channelManager",
      data: { id: value.channelManagerId }
    }, { blockLoader: true });

    if (value.channelManagerId) {
      await handleEndCreate();
      updateSavingStatus(false);
    } else {
      updateSavingStatus(false);
      goPage('calendar');
    }
  }

  /**
   * Инициализация формы
   */
  const { values, handleChange, handleSubmit, submitForm } = useFormik({
    enableReinitialize: true,
    initialValues: {
      channelManagerId: +channelManager || 0,
    },
    onSubmit,
  });

  /**
   * Гайд по подключению менеджера каналов
   */
  const clientGuide = useMemo(() => (
    channelManagerList?.find((cm) => cm.id === values.channelManagerId)?.clientGuide || ''
  ), [channelManagerList, values.channelManagerId])

  /**
   * Предупреждение с айди для менеджера каналов
   */
  const viewedId = useMemo(() => (
    Number(values?.channelManagerId) === 158680 ? firstRoom.id : objectId
  ), [firstRoom, objectId, values?.channelManagerId])

  const buttons = themeButtons()
  return (
    <div className="stepByStepWrp">
      <div className="stepByStepWrp__header">
        <Typography variant="h5" component="h5" className="stepByStepWrp__title">Менеджер каналов</Typography>
      </div>


      <div className="stepByStepWrp__body">
        <div className="navbar__object-id badge bg-success me-0 me-sm-2 mb-3">id: {objectId}</div>
        <from onSubmit={handleSubmit} className="mb-3">
          <FormControl variant="outlined" size="small" fullWidth>
            <InputLabel>Менеджер каналов продаж</InputLabel>
            <Select name="channelManagerId"
                    value={values.channelManagerId}
                    onChange={handleChange}
                    label="Менеджер каналов продаж"
                    className="mb-3"
            >
              <MenuItem className="justify-content-center" value={0}>
                Не использую
              </MenuItem>
              {channelManagerList && channelManagerList.map((item) => (
                  <MenuItem key={item.id}
                            className="justify-content-center"
                            value={item.id}>
                    {item.name}
                  </MenuItem>
                )
              )}
            </Select>
            {!!values.channelManagerId && <>
              <div
                dangerouslySetInnerHTML={{ __html: clientGuide ? clientGuide : "" }}>
              </div>
            </>}

            {values.channelManagerId && viewedId ? (
              <div className="alert alert-warning">
                ID, который требуется ввести в настройках менеджера каналов:
                <br/>
                <br/>
                <b>{viewedId}</b>
              </div>
            ) : null}

          </FormControl>
        </from>
      </div>


      <div className="stepByStepWrp__actions">
        <Button className={`btn`} onClick={() => goPage("rooms")}>Назад</Button>
        <Button className={`btn ${buttons.btnGreen}`}
                onClick={submitForm}>{!values?.channelManagerId ? `Сохранить и продолжить` : `Перейти к заключению договора`}</Button>
      </div>
    </div>
  )
}

export default FastChooseCM
